import styled from 'styled-components'

const Subtitle = styled.p`
color: var(--ultramarine-blue);
text-transform: uppercase;
font-weight: var(--fw-800);
letter-spacing: 2px;
margin-block-end: 10px;
`

export default Subtitle
